export const MOBILEBREAKPOINT = "599px";
export const SMARTPHONEBREAKPOINT = "399px"
export const SHOW_MOBILE = (width) => width < 599;
